import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();
    const navigationType = useNavigationType(); // 'PUSH', 'POP', 'REPLACE'

    useEffect(() => {
        if (navigationType === 'PUSH') {
            // Only scroll on new navigations
            window.scrollTo({ top: 0, behavior: 'auto' }); // or 'smooth'
        }
        if (navigationType === 'POP') {
            // Only scroll on new navigations
            setTimeout(() => window.scrollTo({ behavior: 'auto' }), 1000); // or 'smooth'
        }
    }, [pathname, navigationType]);

    return null;
};

export default ScrollToTop;